import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import Box from '@repo/ui/box'
import Loader from '@repo/ui/loader'
import { LogSection } from '@repo/ui/log-section'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { getTeflOlComments } from '../../../../api/tefl/tefl-ol-comments/get-tefl-ol-comments'

type Props = {
  id: number
}

const TeflOLComments = ({ id }: Props) => {
  const { data: teflOLComments, isPending } = useQuery({
    queryKey: ['tefl-ol-comments'],
    queryFn: () => getTeflOlComments({ teflId: id })
  })

  if (isPending) return <Loader center />

  return (
    <Box className="bg-white-hover rounded-lg border border-grey-light ">
      <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
        Commentaires du Prestataire
      </Typography>
      <div className="h-4" />
      {teflOLComments?.data && teflOLComments.data.length === 0 && (
        <Typography variant="tag" color={tailwindColors.grey.light.active}>
          Aucun commentaire disponible
        </Typography>
      )}
      <LogSection
        data={
          teflOLComments?.data?.map((comment) => ({
            comment: comment.comment,
            updatedAt: new Date(comment.updatedAt)
          })) || []
        }
        dateFormatter={(date) => DateFormatter.ddMMyyyyHHmm(date)}
      />
    </Box>
  )
}

export default TeflOLComments
